import script from "./CategoryEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryEditModal.vue?vue&type=script&setup=true&lang=js"

import "./CategoryEditModal.vue?vue&type=style&index=0&id=35aa4f79&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35aa4f79"]])

export default __exports__